/* eslint-disable @typescript-eslint/no-explicit-any */
import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import Vue from 'vue'
import store from '@/store'
import {LoginRequestType} from '@/form/login/login.types'

@Module({
    namespaced: true,
    name: 'auth',
    store,
    dynamic: true,
})
class AuthModule extends  VuexModule {
    public user: any =  {}
    public userData: any = {}
    public companySubscription: any = null

    @Mutation
    setCompanySubscription(value: any): void { this.companySubscription = value; }

    @Action({rawError: true})
    async loadCompanySubscription(): Promise<void> {
        const user = Vue.auth.user();
        if (user && user.system_admin && !user.company_id) { this.setCompanySubscription(null); return; }
        const response = await Vue.axios.get('/company/subscription');
        this.setCompanySubscription(response.data.data);
    }

    @Mutation
    public async setUser(data:any)
    {
        this.user = data
    }
    @Action({rawError: true})
    async load(): Promise<any> {
        return await Vue.auth.load();
    }
    complete() {
        console.log('user complete')
    }
    error() {
        console.log('user Error')
    }
    @Mutation
    async fetchManual(): Promise<any>{
        //const response = await Api.get('/user')
        //console.log('*** Set user Data ')
        //TODO::Устанавливаем Salon ID
        //this.$store.
        //this.commit("changeSalon", id)

        this.userData = Vue.auth.user()
    }
    @Action
    async fetch(data: any): Promise<any> {
        return Vue.auth.fetch(data)
    }

    @Mutation
    clearUserData(){
        this.userData = {}
        this.companySubscription = null
    }

    @Action({ rawError: true })
    async login(data: LoginRequestType): Promise<any> {
        sessionStorage.removeItem('company_id');
        sessionStorage.removeItem('salon_id');
        const formData = new FormData();
        formData.append('phone', data.phone);
        formData.append('password', data.password);
        //this.userData = {}

        return await Vue.auth.login({
            data: formData,
            redirect: false,
            fetchUser: false,
            staySignedIn: true
        });
    }
    @Action
    async logout(): Promise<void> {
        sessionStorage.removeItem('company-registration-request');
        sessionStorage.removeItem('company_id');
        sessionStorage.setItem('userData','')
        sessionStorage.setItem('salon_id','')
        Vue.auth.logout()
        location.reload();

        //await Vue.auth.logout({ redirect: { name: RouterNameEnum.AuthLogin } });
    }
}

export const AuthStore = getModule(AuthModule);
